<p>memgroupchat works!</p>
